import { useParams } from "react-router-dom";
import useOrganizations from "../../hooks/useOrganizations";

// The organization in the current route, if any, with its name once loaded.
export const useCurrentOrganization = () => {
  const { organizationId } = useParams();
  const { organizations } = useOrganizations();
  const current = organizations?.find((o) => o._id === organizationId);
  return { id: organizationId ?? null, name: current?.name ?? null, organizations };
};
